import { AccountInfo, AuthenticationResult, Configuration, EventMessage, EventType, PublicClientApplication } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";

export const msalConfig: Configuration = {
  auth: {
    authority:
      "https://login.microsoftonline.com/" + process.env.REACT_APP_TENANT_ID,
    clientId: process.env.REACT_APP_CLIENT_ID || '',
    redirectUri: "/",
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
};

export const pca = new PublicClientApplication(msalConfig);

const accounts = pca.getAllAccounts();
if (accounts.length > 0) pca.setActiveAccount(accounts[0]);

pca.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    pca.setActiveAccount(account);
    // eslint-disable-next-line scanjs-rules/assign_to_pathname
    if (payload.state) window.location.pathname = payload.state;
  }
});

pca.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    pca.setActiveAccount(account);
  }
});

export const authRequest = {
  scopes: ["api://" + process.env.REACT_APP_API_CLIENT_ID + "/access_as_user",],
  state: window.location.pathname,
};

interface Account extends AccountInfo {
  idTokenClaims?: {
    roles?: string[]
  }
}


export const rollen = {
  admin: "Admin",
  betrieb: "Betrieb",
  technik: "Technik",
  netzwirtschaft: "Netzwirtschaft",
  netzplanung: "Netzplanung",
  gast: "Gast",
  backend: "Backend",
  everyone: "everyone",
};

export function isAuthorized(rolle: string[]): boolean {
  if (rolle.includes(rollen.everyone)) {return true;}  
  
  const { instance } = useMsal();
  const account: Account | null = instance.getActiveAccount();
  const userRoles = account?.idTokenClaims?.roles;

  if (userRoles) {
    return rolle.filter((element) => userRoles.includes(element)).length > 0;
  }
  else {
    return false;
  }

}